<div class="all-set d-flex align-items-center justify-content-center">
  <img
    src="/assets/icons/avyna/logo.svg"
    [alt]="'onboarding.shared.logoAlt' | translate"
    class="all-set__brand-mark"
  />
  @if (state === 'completing') {
  <div class="all-set__process-card">
    <!-- Card header -->
    <div class="all-set__card-header text-center">
      <img
        src="/assets/icons/avyna/logo.svg"
        [alt]="'onboarding.shared.logoAlt' | translate"
        class="all-set__brand-logo mb-3"
      />
      <h1 class="all-set__title-text">{{ 'onboarding.setup.allSet.settingUpTitle' | translate }}</h1>
      <p class="all-set__subtitle-text">
        {{ 'onboarding.setup.allSet.thisWillTakeAMoment' | translate }}
      </p>
    </div>

    <!-- Step list -->
    <ul class="all-set__step-list">
      @for (step of steps(); track step.id) {
      <li
        class="all-set__step-row"
        [class.is-active]="step.state === 'loading'"
        [class.is-done]="step.state === 'completed'"
        [class.is-pending]="step.state === 'pending'"
      >
        <span class="all-set__step-icon">
          @switch (step.state) { @case ('completed') {
          <mat-icon class="all-set__step-icon-done icon-md">check_circle</mat-icon>
          } @case ('loading') {
          <mat-spinner [diameter]="20" [strokeWidth]="2"></mat-spinner>
          } @default {
          <mat-icon class="all-set__step-icon-pending icon-md">radio_button_unchecked</mat-icon>
          } }
        </span>
        <span class="all-set__step-label">{{ step.label | translate }}</span>
      </li>
      }
    </ul>
  </div>
  }

  @if (state === 'success') {
  <div class="all-set__card text-center">
    <div class="d-flex justify-content-center mb-4">
      <div class="all-set__icon-circle all-set__icon-circle--success">
        <mat-icon class="all-set__icon icon-lg">check_circle</mat-icon>
      </div>
    </div>

    <h1 class="fs-3 fw-bold text-body mb-3">{{ 'onboarding.setup.allSet.successTitle' | translate }}</h1>
    <p class="text-body-secondary mb-3">
      {{ 'onboarding.setup.allSet.successDesc' | translate }}
    </p>

    <p class="small text-body-secondary mb-3">
      {{ 'onboarding.setup.allSet.autoRedirect' | translate }}
    </p>

    <!-- Re-login notice -->
    <div class="all-set__notice d-flex align-items-center justify-content-center gap-2">
      <mat-icon class="all-set__notice-icon icon-md">login</mat-icon>
      <span>{{ 'onboarding.setup.allSet.reLoginWarning' | translate }}</span>
    </div>
  </div>
  }

  @if (state === 'error') {
  <div class="all-set__card text-center">
    <div class="d-flex justify-content-center mb-4">
      <div class="all-set__icon-circle all-set__icon-circle--error">
        <mat-icon class="all-set__icon icon-lg">error</mat-icon>
      </div>
    </div>

    <h1 class="fs-3 fw-bold text-body mb-3">{{ 'onboarding.setup.allSet.errorTitle' | translate }}</h1>
    <p class="all-set__error-text mb-3">{{ errorMessage }}</p>
    <p class="small text-body-secondary mb-0">
      {{ 'onboarding.setup.allSet.errorDesc' | translate }}
    </p>
  </div>
  }
</div>
